module.exports = __webpack_public_path__ + "img/mh5.386427f6.jpg";